/**
 * XOF (FCFA) formatting.
 *
 * XOF has no minor unit in circulation, so amounts are whole francs. Values
 * cross the API as decimal *strings* (never floats) to avoid IEEE-754 drift on
 * money — see implementation/PHASE-003 conventions.
 */
export type Money = { amount: string; currency: string }

const nf = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 })

/** "2 500 FCFA" — French grouping, per the design's own sample data. */
export function formatMoney(money: Money): string {
  const n = Number(money.amount)
  if (!Number.isFinite(n)) return `— ${money.currency}`
  const unit = money.currency === 'XOF' ? 'FCFA' : money.currency
  return `${nf.format(Math.round(n))} ${unit}`
}

/** Sum without float error: parse to integer francs. */
export function sumMoney(items: readonly Money[], currency = 'XOF'): Money {
  const total = items.reduce((acc, m) => acc + Math.round(Number(m.amount) || 0), 0)
  return { amount: total.toFixed(2), currency }
}

export function xof(amount: number | string): Money {
  return { amount: typeof amount === 'number' ? amount.toFixed(2) : amount, currency: 'XOF' }
}
